import AppConfig from '@/config/appConfig'

export default {
    methods: {
        isAyresResearchPortal(){
            return AppConfig.appName=='research.ayresim.com'
        },
        isAyresgroupPortal(){
            return AppConfig.appName=='ayresgroup.com.ar'
        },
        isAyresInstitutionalPortal(){
            return AppConfig.appName=='institutional.ayresim.com'
        }
    }
}